import * as PIXI from 'pixi.js'

import parseStyles from '../../style/parser'

import shallowEqualObjects from './shallowEqual'

PIXI.DisplayObject.prototype._mudraStyle = null
PIXI.DisplayObject.prototype._mudraRAWStyle = null
Object.defineProperty(PIXI.DisplayObject.prototype, 'style', {
  get() {
    return this._mudraStyle
  },
  set(value) {
    if (!shallowEqualObjects(this._mudraRAWStyle, value)) {
      this._mudraStyle = parseStyles(value)
    }
    this._mudraRAWStyle = value
  },
})
